import {safeHtml} from '@helper/sanitize-html';

export default function HospitalIntro({
    business_name,
    address,
    business_phone_number,
    business_image,
    description,
    mapUrl, // thêm prop mapUrl
    onOpenMap, // thêm prop callback mở map
    icons = {
        address: '/bw_image/ic_location.svg',
        phone: '/bw_image/ic_call.svg',
    },
}) {
    const handleClickAddress = () => {
        if (mapUrl && onOpenMap) {
            onOpenMap(mapUrl);
        }
    };

    return (
        <section className="hospital-intro">
            <h2 className="hospital-intro-title">{business_name}</h2>

            <div className="hospital-info">
                <p
                    className={mapUrl ? 'clickable-address' : ''}
                    onClick={handleClickAddress}
                    style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: mapUrl ? 'pointer' : 'default'}}>
                    <img src={icons.address} alt="Địa chỉ" className="icon" />
                    <span>{address}</span>
                </p>
                <p style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <img src={icons.phone} alt="Điện thoại" className="icon" />
                    <a href={`tel:${business_phone_number.replace(/\s+/g, '')}`} className="hospital-phone">
                        {business_phone_number}
                    </a>
                </p>
            </div>

            <div className="hospital-grid">
                <div className="hospital-image">
                    <img src={business_image} alt={business_name} />
                </div>
                <div className="hospital-content">
                    <div className="hospital-description">
                        {description && <div dangerouslySetInnerHTML={safeHtml(description)} />}
                    </div>
                </div>
            </div>
        </section>
    );
}
